export default __webpack_public_path__ + "static/media/SHIVAYOGI.31f070b7.JPG";